import {createContext, useContext} from 'react';
import {useModuleFactory} from '@injex/react-plugin';
import {NotificationSettingsModel} from '../model/NotificationSettingsModel.mdl';

export const SettingsListContext = createContext<{model: NotificationSettingsModel}>({model: null});
export function NotificationSettingsListWithContext({children}: {children: React.ReactNode}) {
    const model = useModuleFactory<NotificationSettingsModel>('notificationSettingsModel');
    return <SettingsListContext.Provider value={{model}}>{children}</SettingsListContext.Provider>;
}
export const useNotificationSettingsListContext = () => useContext(SettingsListContext);
